import React from 'react';
// import PropTypes from 'prop-types';
import {
  Alert,
  Platform,
} from 'react-native';
import { Auth } from 'aws-amplify';
import AORTypes from './types';
import RNFetchBlob from './fetch';
import ImagePicker from './image-picker';
import AudioPicker from './audio-picker';
import { sleep } from './modules/Utils';
import { translate } from './locales/i18n';

class Uploader extends React.Component {
  static async getToken() {
    const token = await Auth.currentSession()
      .then((response) => response.accessToken.jwtToken)
      .catch((error) => {
        console.log(error);
        return '';
      });

    return token;
  }

  static uploadDataOnce(signedUrl, metadata, data) {
    console.log('uploadDataOnce');
    console.log('data');
    console.log(metadata);
    console.log(data);

    if (Platform.OS !== 'web') {
      const formData = [
        {
          name: 'key',
          data: signedUrl.fields.key,
        },
        {
          name: 'AWSAccessKeyId',
          data: signedUrl.fields.AWSAccessKeyId,
        },
        {
          name: 'x-amz-security-token',
          data: signedUrl.fields['x-amz-security-token'],
        },
        {
          name: 'policy',
          data: signedUrl.fields.policy,
        },
        {
          name: 'signature',
          data: signedUrl.fields.signature,
        },
        {
          name: 'x-amz-meta-user',
          // data: signedUrl.fields['x-amz-meta-user'],
          data: metadata.user,
        },
        {
          name: 'x-amz-meta-name',
          // data: signedUrl.fields['x-amz-meta-name'],
          data: metadata.name,
        },
        {
          name: 'x-amz-meta-type',
          // data: signedUrl.fields['x-amz-meta-name'],
          data: metadata.type,
        },
      ];
      if (metadata.isVertical !== undefined) {
        formData.push({
          name: 'x-amz-meta-isVertical',
          // data: signedUrl.fields['x-amz-meta-isVertical'],
          data: metadata.isVertical ? 'True' : 'False',
        });
      }
      if (metadata.app !== undefined) {
        formData.push({
          name: 'x-amz-meta-app',
          // data: signedUrl.fields['x-amz-meta-app'],
          data: metadata.app,
        });
      }
      if (metadata.endpoint !== undefined) {
        formData.push({
          name: 'x-amz-meta-endpoint',
          // data: signedUrl.fields['x-amz-meta-endpoint'],
          data: metadata.endpoint,
        });
      }
      formData.push({
        name: 'x-amz-meta-callback',
        data: signedUrl.fields['x-amz-meta-callback'],
      });

      let path = data;
      if (Platform.OS === 'ios') {
        if (path.startsWith('file://')) {
          path = path.substring(7);
          path = unescape(path);
        }
      }

      // The file MUST be the last item in the list!!!
      formData.push({
        name: 'file',
        data: RNFetchBlob.wrap(path),
        filename: signedUrl.fields.key,
      });

      console.log('formData');
      console.log(formData);

      return RNFetchBlob.fetch(
        'POST',
        signedUrl.url,
        { 'Content-Type': 'multipart/form-data' },
        formData
      )
        .then((result) => {
          console.log('upload success');
          console.log(result);
          return true;
        })
        .catch((err) => {
          console.log('upload error');
          console.log(err);
          return false;
        });
    }

    const formData = new FormData();

    // console.log('key');
    // console.log(signedUrl.fields.key);
    formData.append('key', signedUrl.fields.key);

    // console.log('AWSAccessKeyId');
    // console.log(signedUrl.fields.AWSAccessKeyId);
    formData.append('AWSAccessKeyId', signedUrl.fields.AWSAccessKeyId);

    // console.log('x-amz-security-token');
    // console.log(signedUrl.fields['x-amz-security-token']);
    formData.append('x-amz-security-token', signedUrl.fields['x-amz-security-token']);

    // console.log('policy');
    // console.log(signedUrl.fields.policy);
    formData.append('policy', signedUrl.fields.policy);

    // console.log('signature');
    // console.log(signedUrl.fields.signature);
    formData.append('signature', signedUrl.fields.signature);

    // console.log('x-amz-meta-user');
    // console.log(metadata.user);
    formData.append('x-amz-meta-user', metadata.user);

    if (metadata.app) {
      // console.log('x-amz-meta-app');
      // console.log(metadata.app);
      formData.append('x-amz-meta-app', metadata.app);
    }
    if (metadata.endpoint) {
      // console.log('x-amz-meta-endpoint');
      // console.log(metadata.endpoint);
      formData.append('x-amz-meta-endpoint', metadata.endpoint);
    }
    // formData.append('x-amz-meta-isVertical', metadata.isVertical);

    // console.log('x-amz-meta-name');
    // console.log(metadata.name);
    formData.append('x-amz-meta-name', metadata.name);

    // console.log('x-amz-meta-type');
    // console.log(metadata.type);
    formData.append('x-amz-meta-type', metadata.type);

    // console.log('x-amz-meta-callback');
    // console.log(signedUrl.fields);
    // console.log(signedUrl.fields['x-amz-meta-callback']);
    formData.append('x-amz-meta-callback', signedUrl.fields['x-amz-meta-callback']);

    // console.log('file');
    // console.log(data);
    // console.log(typeof signedUrl.fields.key);
    // console.log(signedUrl.fields.key);
    formData.append('file', data, signedUrl.fields.key);

    // console.log('url');
    // console.log(signedUrl);
    // console.log(signedUrl.url);

    return fetch(signedUrl.url, {
      method: 'POST',
      headers: {
      },
      body: formData,
    })
      .then((result) => {
        console.log('upload success');
        console.log(result);
        if (!result.ok) {
          return false;
        }

        return true;
      })
      .catch((err) => {
        console.log('upload error');
        console.log(err);
        return false;
      });
  }

  static uploadData(signedUrl, metadata, data, levels) {
    console.log('uploadData');

    const recursionLevels = levels || 0;
    const delay = 3 + recursionLevels;

    return Uploader.uploadDataOnce(signedUrl, metadata, data)
      .then(async (result) => {
        console.log('uploadData complete');
        if (!result) {
          console.log('uploadData retry');
          await sleep(delay);
          return Uploader.uploadData(signedUrl, metadata, data, recursionLevels + 1);
        }
        return undefined;
      })
      .catch(async (err) => {
        console.log('uploadData failed');
        console.log(err);
        await sleep(delay);
        return Uploader.uploadData(signedUrl, metadata, data, recursionLevels + 1);
      });
  }

  constructor(props, context) {
    super(props, context);

    this.handleUrlUpload = this.handleUrlUpload.bind(this);
    this.handleWebUpload = this.handleWebUpload.bind(this);
    this.handleMobileAudioUpload = this.handleMobileAudioUpload.bind(this);
    this.handleMobilePhotoUpload = this.handleMobilePhotoUpload.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
  }

  handleUrlUpload(uuidParent, url, name, mutation, updateFunc, onCompleteFunc, metadata) {
    let response; // this is a promise to get data and type
    let data = null;
    let type = 'image/'; // TODO(clairbee): complete this;

    if (Platform.OS === 'web') {
      response = fetch(url, {
        method: 'GET',
        // credentials: 'include',
        // mode: 'no-cors',
        // headers: {
        // },
      })
        .then((result) => {
          console.log('download finished');
          console.log(result);
          // if (!result.ok) {
          //   return false;
          // }
          // console.log('download success');

          return result.blob().then((blob) => {
            // console.log('blob');
            // console.log(blob);
            // console.log(result);

            data = blob;
            type = blob.type;

            return blob.size !== 0 && blob.type !== '';
            // return true;
          }).catch((err) => {
            console.log('download error');
            console.log(err);
            return false;
          });
        })
        .catch((err) => {
          console.log('download error');
          console.log(err);
          return false;
        });
      console.log('response');
      console.log(response);
    } else {
      // const response = RNFetchBlob.fetch('GET', url,
      //   {
      //     // 'Content-Type': 'multipart/form-data',
      //   },
      //   formData)
      //   .then((result) => {
      //     console.log('download success');
      //     console.log(result);
      //     return true;
      //   })
      //   .catch((err) => {
      //     console.log('download error');
      //     console.log(err);
      //     return false;
      //   });
      // data = response.data;

      const {
        config,
        // fs,
      } = RNFetchBlob;
      // let CacheDir = fs.dirs.CacheDir;
      const options = {
        fileCache: true,
        // addAndroidDownloads : {
        //   useDownloadManager : false,
        //   notification : false,
        //   path:  CacheDir + "/profile_" + Math.floor(date.getTime() + date.getSeconds() / 2) + ext,
        //   description : 'Profile Image'
        // }
      };
      response = config(options).fetch('GET', url)
        .then((res) => {
          console.log('Download Success !');
          console.log(res);

          // FIXME(clairbee): the following line was not tested.
          //                  Should it be "res.data|body|..." instead of "res.blob()"?
          res.blob().then((blob) => {
            // console.log('blob');
            // console.log(blob);

            // type = res.headers.get('content-type');
            type = blob.type;
            data = blob;
            return blob;
          });
        });
      console.log('response');
      console.log(response);
    }

    return response.then((result) => {
      // console.log('response resolved');
      // console.log(result);
      // console.log(data);
      // console.log(type);

      if (!result || data === null) {
        return onCompleteFunc(false);
      }

      const md = metadata;
      md.name = name;
      md.type = type; // type gets resolved when the response is resolved

      return this.handleUpload(uuidParent, mutation, updateFunc, onCompleteFunc, md, data);
    });
  }

  handleWebUpload(elementId, uuidParent, mutation, updateFunc, onCompleteFunc, metadata, e) {
    console.log('select on the web');
    const input = document.getElementById(elementId);
    if (input.value === 'undefined' || input.value === null || input.value === '') {
      console.log('no file selected yet');
      onCompleteFunc(false);
      return Promise.resolve(false);
    }

    console.log(e);
    console.log(e.target);
    console.log(e.target.files[0]);

    const file = e.target.files[0];
    const { name, type } = file;

    const md = metadata;
    md.name = name;
    md.type = type;

    return this.handleUpload(uuidParent, mutation, updateFunc, onCompleteFunc, md, file);
  }

  handleMobileAudioUpload(title, uuidParent, mutation, updateFunc, onCompleteFunc, metadata) {
    const options = {
      title,
      type: AudioPicker.types.audio,
      noData: true,
      storageOptions: {
        skipBackup: true,
      },
    };
    console.log('calling AudioPicker');
    const callback = (response) => {
      console.log('AudioPicker response');
      console.log(response);

      if (!response || response.error || response.didCancel || !response.uri) {
        console.log('AudioPicker error');
        console.log(response);
        onCompleteFunc(false);
        return Promise.resolve(false);
      }

      const data = response.uri;

      const md = metadata;
      md.name = response.name;
      md.type = response.type;

      return this.handleUpload(uuidParent, mutation, updateFunc, onCompleteFunc, md, data);
    };

    AudioPicker.pick(options) // , callback) // 'callback' is ignored in Android
      .then((result) => callback(result))
      .catch((error) => {
        console.log('pick failed');
        console.log(error.message);
        onCompleteFunc(false);
      });
  }

  handleMobilePhotoUpload(title, uuidParent, mutation, updateFunc, onCompleteFunc, metadata) {
    const options = {
      title,
      // quality: 0.2, // TODO(clairbee): will 0.2 suffice for avatars???
      mediaType: 'photo',
      storageOptions: {
        skipBackup: true,
        path: 'images',
      },
      noData: true,
    };
    ImagePicker.launchImageLibrary(options, async (response) => {
      // console.log(response);
      if (response.error || response.didCancel || !response.uri || !response.fileName) {
        onCompleteFunc(false);
        return Promise.resolve(false);
      }

      const data = response.uri;

      const {
        fileName, isVertical, type,
      } = response;

      const md = metadata;
      md.name = fileName;
      md.isVertical = isVertical;
      md.type = type.toString();

      return this.handleUpload(uuidParent, mutation, updateFunc, onCompleteFunc, md, data);
    });
  }

  async handleUpload(uuidParent, mutation, updateFunc, onCompleteFunc, md, data) {
    const {
      name, isVertical, type,
    } = md;
    // const token = await Uploader.getToken();
    const {
      user,
    } = this.props;

    console.log(`uuid: ${user.attributes.sub}`);
    console.log(`fileName: ${name}`);
    console.log(`isVertical: ${isVertical}`);
    console.log(`type: ${type}`);
    // console.log(`data: ${data}`);

    const metadata = md;
    metadata.uuid = uuidParent;
    metadata.user = user.attributes.sub;
    // metadata.name = name;

    if (isVertical !== undefined) {
      metadata.isVertical = !!isVertical;
    }

    // const apiRequest = {
    //   body: {
    //     token, // FIXME(clairbee): replace this with the native Cognito based auth for API Gateway
    //     ...metadata,
    //   },
    // };

    console.log('calling AppSync');
    mutation(metadata).then((response) => {
      //   return true;
      // }).catch((error) => {

      // });

      // console.log('calling API');
      // console.log(apiRequest);
      // await API.post(apiName, apiPath, apiRequest).then(async (apiResponse) => {
      console.log('success');
      console.log(response);

      // At this point 'response.data' contains either
      // - addImage
      // - addUserImage
      // - addTrack
      // TODO(clairbee): There is a probably a smarter way to extract the results.

      let signedUrl;
      if (response.data.addImage) {
        signedUrl = JSON.parse(response.data.addImage.signedUrl);
      } else if (response.data.addUserImage) {
        signedUrl = JSON.parse(response.data.addUserImage.signedUrl);
      } else if (response.data.addTrack) {
        signedUrl = JSON.parse(response.data.addTrack.signedUrl);
      }

      // console.log('data');
      // console.log(data);

      const promises = [];
      promises.push(Uploader.uploadData(signedUrl, metadata, data)
        .catch((err) => {
          onCompleteFunc(false);
          return err;
        }));

      if (updateFunc) {
        promises.push(updateFunc()
          .then((result) => {
            console.log('data update success');
            console.log(result);
            return result;
          })
          .catch((err) => {
            console.log('data update failed');
            console.log(err);
            onCompleteFunc(false);
            return err;
          }));
      }

      Promise.all(promises)
        .then((result) => {
          onCompleteFunc(true);
          return result;
        });

      return true;
    }).catch((error) => {
      console.log('failed');
      console.log(error);

      // FIXME(clairbee): clean up: error.response is the leftover from the API Gateway
      if (error.response) {
        console.log(error.response.status);
        if (error.response.status === 413) {
          Alert.alert(
            translate('error'),
            translate('upload_error'),
            [
              {
                text: translate('ok'),
              },
            ]
          );
        }
      }
      // console.log(error.response);
      // console.log(error);

      // FIXME(clairbee): shouldn't we call "onCompleteFunc(true);" anyway?
      return false;
    });
  }

  render() {
    return (
      <>
      </>
    );
  }
}

Uploader.defaultProps = {
  user: null,
};

Uploader.propTypes = {
  user: AORTypes.AWS.Cognito.User,
};

export default Uploader;
